module.exports = __webpack_public_path__ + "static/img-velo-40d177358669f5b77f55e8ea1081cb85.svg";